import { motion } from "framer-motion";
import { MapPin, Phone, Navigation } from "lucide-react";

const MAP_SRC = "https://maps.google.com/maps?q=50.71482,-2.07379&z=16&output=embed";

export const MapSection = () => {
    return (
        <section id="find-us" className="relative py-20 sm:py-28 bg-indigo-950 overflow-hidden pv-noise" data-testid="find-us-section">
            <div className="absolute inset-0 pv-stars opacity-30 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto px-6 sm:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.9 }}
                        className="lg:col-span-4"
                    >
                        <p className="text-3xl sm:text-4xl tracking-[0.2em] uppercase font-semibold text-white mb-8" data-testid="find-us-heading">Find us</p>
                        <div className="flex items-start gap-4 mb-8">
                            <MapPin className="w-6 h-6 text-blue-300 shrink-0 mt-1" />
                            <address className="not-italic text-lg leading-relaxed font-medium text-white" data-testid="find-us-address">
                                Unit B2, 46 Holton Road<br />
                                Holton Heath Industrial Park<br />
                                Poole BH16 6LT
                            </address>
                        </div>
                        <a href="tel:+447481776151" className="inline-flex items-center gap-3 text-white hover:text-blue-300 transition-colors mb-8" data-testid="find-us-phone">
                            <Phone className="w-5 h-5 text-blue-300" />
                            <span className="text-lg font-medium">07481 776151</span>
                        </a>
                        <div>
                            <motion.a
                                whileTap={{ scale: 0.97 }}
                                href="https://www.google.com/maps/dir/?api=1&destination=50.71482,-2.07379"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-3 bg-white hover:bg-blue-50 text-indigo-950 text-sm tracking-[0.12em] uppercase font-bold px-8 py-4 transition-colors duration-300"
                                data-testid="find-us-directions-button"
                            >
                                <Navigation className="w-4 h-4" /> Get directions
                            </motion.a>
                        </div>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.9, delay: 0.15 }}
                        className="lg:col-span-8 border border-indigo-400/25"
                        data-testid="find-us-map-panel"
                    >
                        <iframe
                            src={MAP_SRC}
                            className="w-full h-[380px] sm:h-[440px] border-0"
                            loading="lazy"
                            title="Planet Valet location — Holton Heath Industrial Park, Poole"
                            data-testid="find-us-map"
                        />
                    </motion.div>
                </div>
            </div>
        </section>
    );
};
